import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'

const TOKEN_KEY = 'finance_admin_jwt'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t)
  else localStorage.removeItem(TOKEN_KEY)
}

const apiBase = (process.env.VUE_APP_API_BASE || process.env.VUE_APP_API_TARGET || '')
  .trim()
  .replace(/\/$/, '')

const service = axios.create({
  baseURL: apiBase || '/',
  timeout: 30000,
})

service.interceptors.request.use((config) => {
  const token = getToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

service.interceptors.response.use(
  (res) => {
    const body = res.data
    if (body && typeof body.code === 'number' && body.code !== 0) {
      Message.error(body.msg || '请求失败')
      if (body.code === 401) {
        setToken('')
        router.replace({ name: 'Login' })
      }
      return Promise.reject({ isApiError: true, code: body.code, msg: body.msg })
    }
    return body
  },
  (err) => {
    const msg = err.response?.data?.msg || err.message || '网络错误'
    Message.error(msg)
    if (err.response?.status === 401) {
      setToken('')
      router.replace({ name: 'Login' })
    }
    return Promise.reject(err)
  }
)

export default service
